import React from "react";
import { ShieldCheck } from "lucide-react";

export default function RightsCard({ index, text }) {
  return (
    <div
      data-testid={`rights-card-${index}`}
      className="bg-white border-l-8 border-l-red-600 border-y border-r border-zinc-200 p-5 rounded-r-xl shadow-sm flex gap-3"
    >
      <div className="flex-shrink-0 mt-0.5">
        <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center">
          <ShieldCheck className="w-5 h-5 text-red-600" strokeWidth={2.5} />
        </div>
      </div>
      <p className="text-lg leading-snug text-zinc-900 font-medium flex-1">{text}</p>
    </div>
  );
}
